/**
 * @generated SignedSource<<8889e4a506d1c8568ff60cfe8761b81f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SidebarOnboardingPanelFragment$data = {
  readonly testOrdersCount: number;
  readonly treeMenuReferringInfo: {
    readonly daysOfTrial: number;
    readonly firstNotPublishedProductID: number | null;
    readonly hasFirstCustomizableProduct: boolean;
    readonly hasPublishedProduct: boolean;
    readonly hasStoreConnected: boolean;
    readonly isAdministrator: boolean;
    readonly isComposerEnabled: boolean;
    readonly isExternalLinksHidden: boolean;
    readonly isHelpWidgetHidden: boolean;
    readonly isMenuHidden: boolean;
    readonly isNoViewsPlan: boolean;
    readonly isSubscriptionCanceled: boolean;
    readonly isSubscriptionSubStatusBlocked: boolean;
    readonly isToolbarHidden: boolean;
    readonly isTrial: boolean;
    readonly isVisibleSubscribePlan: boolean;
    readonly noValidSubscriptionReason: string | null;
    readonly planVersion: number;
    readonly remoteUrl: string | null;
    readonly sellerAppsumoMarketplaceID: number | null;
    readonly subscriptionCancel: string | null;
    readonly toolbarForceTools: boolean;
    readonly urlComposer: string | null;
    readonly userType: number;
  };
  readonly user: {
    readonly email: string;
    readonly name: string;
    readonly userID: number;
  };
  readonly " $fragmentType": "SidebarOnboardingPanelFragment";
};
export type SidebarOnboardingPanelFragment$key = {
  readonly " $data"?: SidebarOnboardingPanelFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SidebarOnboardingPanelFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SidebarOnboardingPanelFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserInfo",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "testOrdersCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TreeMenuReferringInfo",
      "kind": "LinkedField",
      "name": "treeMenuReferringInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "daysOfTrial",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstNotPublishedProductID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasFirstCustomizableProduct",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPublishedProduct",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasStoreConnected",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAdministrator",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isComposerEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExternalLinksHidden",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isHelpWidgetHidden",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMenuHidden",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isNoViewsPlan",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSubscriptionCanceled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSubscriptionSubStatusBlocked",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isToolbarHidden",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTrial",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isVisibleSubscribePlan",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noValidSubscriptionReason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "planVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remoteUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sellerAppsumoMarketplaceID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subscriptionCancel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "toolbarForceTools",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlComposer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "8ed28588a22085f8c4e0b5dd61017fbc";

export default node;
